import React from 'react';
import TopBar from '../../../Components/TopBar';
import BusinessSwitcher from '../BusinessSwitcher';
import Notifications from '../Notifications';
import Page from '../../../Components/Containers/Page';
import { useSession } from '../../../Components/Session';
import { Sections } from '../../../Components/Containers/Section';
import UpdatePrompt from '../../../Components/UpdatePrompt';
import MobileNotifications from '../Widgets/MobileNotifications';
import WorkWidget from '../../Work/Widget';
import DailyTracker from './DailyTracker';
import GetStarted from './GetStarted';
import Finances from './Finances';
import Inbox from './Inbox';
import TriggersWidget from '../Widgets/Triggers';
import JobSummary from './JobSummary';

const HomeRedesign = () => {
    const {showDarkMode} = useSession();

    return (
        <>
            <TopBar
                left={
                //     <BusinessSwitcher />
                // }
                // title={
                    <img src={showDarkMode ? "/logo-name-horizontal-36-dark.png" : "/logo-name-horizontal-36.png"}
                        // className="h-[36px] w-[175px] mt-1 mx-auto"
                        className="h-[25px] w-auto mt-1 mx-auto"
                        alt="getSoapy"
                        width="175"
                        height="36"
                        onClick={() => window.location.reload(true)}
                    />
                }
                right={<div className="flex flex-row items-center gap-4 md:gap-6">
                    <BusinessSwitcher />
                    <Inbox />
                    <Notifications />
                </div>}
            />
            <Page lightBg>
                <Sections>
                    <GetStarted />
                    <UpdatePrompt />
                    <MobileNotifications />
                    <TriggersWidget />
                    <WorkWidget />
                    <DailyTracker />
                    <Finances />
                    <JobSummary />
                </Sections>
            </Page>
        </>
    );
};

export default HomeRedesign;
